import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Visual breadcrumb trail (pairs with breadcrumbLd for schema). Silo/Bruce-Clay style hierarchy.
export function Breadcrumbs({ items, tone = "dark" }) {
  const linkCls = tone === "light" ? "font-label text-[9px] text-champagne hover:underline" : "font-label text-[9px] text-rosemetal hover:underline";
  const lastCls = tone === "light" ? "font-label text-[9px] text-cream/60" : "font-label text-[9px] text-muted-foreground";
  const chevCls = tone === "light" ? "w-3 h-3 text-cream/40" : "w-3 h-3 text-muted-foreground/50";
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1.5 mb-6">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.path} className="flex items-center gap-1.5">
            {last ? (
              <span className={lastCls}>{it.name}</span>
            ) : (
              <Link to={it.path} className={linkCls}>{it.name}</Link>
            )}
            {!last && <ChevronRight className={chevCls} />}
          </span>
        );
      })}
    </nav>
  );
}
